import React from 'react';
import { Form } from 'antd';
import style from './index.less';
class IndexForm extends React.Component{

    render(){
        return(
            <div>
                <h1 className={style['title']}>{this.props.title}</h1>
                <Form onSubmit={this.props.onSubmit} className={style['form']}>
                    {this.props.children}
                </Form>
            </div>
        );
    }


}

export default IndexForm;



// WEBPACK FOOTER //
// ./src/components/IndexForm/index.js